import moment from 'moment'
import platform from 'platform'

export * from './audits'
export * from './charts'
export * from './dates'
export * from './expenses'
export const STAGING = 'staging'
export const PRODUCTION = 'production'
export const DEVELOPMENT = 'development'

export const EMAIL_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/
// export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\d\D]{8,}$/
export const PHONE_NUMBER_REGEX = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im

export const GL_CODE_PARAM = 'GLcode'
export const MY_VENDOR_PARAM = 'MyVendor'
export const JOB_CODE_PARAM = 'ProjectCode'
export const PAYMENT_TYPE_PARAM = 'PaymentType'
export const PAYMENT_STATUS_PARAM = 'PaymentStatus'
export const EXPENSE_CATEGORY_PARAM = 'ExpenseCategory'
export const PROPERTY_NAME_PARAM = 'PropertyName'
export const UNIT_NO_PARAM = 'UnitNo'
export const WORKFLOW_STATUS_PARAM = 'WorkflowStatus'
export const DEPARTMENT_PARAM = 'Department'

export const MY_VENDOR_TAG = 'myVendor'
export const MY_GL_CODE_TAG = 'myGLCode'
export const MY_EXPENSE_CATEGORY_TAG = 'myExpenseCategory'

export const SIGNUP_FORM = 'signupForm'
export const REQUIRED_TEXT = 'Required'
export const USER_PROFILE_FORM = 'userProfile'
export const EDIT_DOCUMENT_FORM = 'editDocument'

export const INVALID_NUMBER = 'Invalid number.'
export const CHANGE_PASSWORD_FORM = 'changePassword'
export const INVALID_PHONE_NUMBER = 'Phone number is not valid.'
export const INVALID_EMAIL = 'Please enter a valid email address.'
export const PASSWORD_MIN_LENGTH = 'Password should should be aminimum of 6 characters'
export const INVALID_PASSWORD =
  'Password must be six characters and contain at least one letter and one number.'

export const PASSWORD_REQUIREMENTS =
  'Password must be at least 8 characters, contain one uppercase letter, one lowercase letter, and one number'

export const NON_FINANCIAL_DATE_FIELDS = {
  enddate: 'Check-in Date',
  startdate: 'Check-out Date',
}

export const DATE_FIELDS = ['enddate', 'startdate', 'DueDate', 'PostingDate']
export const FINANCIAL_FIELDS = ['LineItemTotal', 'Tax', 'Tip', 'BalanceDue', 'Total']

export const LABEL_FINANCIAL_FIELDS = {
  LineItemTotal: 'Net Amount',
  Tax: 'Tax Amount',
  Tip: 'Tip',
  BalanceDue: 'Amount Due',
  Total: 'Invoice Amount',
}

export const INVOICE_LABEL_FINANCIAL_FIELDS = ['Total', 'LineItemTotal', 'Tax']

export const ALL_LABEL_FINANCIAL_FIELDS = ['Total', 'LineItemTotal', 'Tax', 'Tip', 'BalanceDue']

export const LINE_ITEMS_TOTAL_FIELDS = {
  Tax: 'Tax',
  Total: 'Total',
  UnitPrice: 'UnitPrice',
}

export const SIGNUP_COUNTRY_OPTIONS = [
  {
    name: 'USA',
    value: 'USA',
  },
  {
    name: 'India',
    value: 'India',
  },
  {
    name: 'Finland',
    value: 'Finland',
  },
]

export const SIGNUP_INDUSTRY_OPTIONS = [
  {
    name: 'Atria',
    value: 'Atria',
  },
  {
    name: 'Callisto',
    value: 'Callisto',
  },
  {
    name: 'Dione',
    value: 'Dione',
  },
  {
    name: 'Ganymede',
    value: 'Ganymede',
  },
  {
    name: 'Hangouts Call',
    value: 'Hangouts Call',
  },
  {
    name: 'Luna',
    value: 'Luna',
  },
  {
    name: 'Oberon',
    value: 'Oberon',
  },
  {
    name: 'Phobos',
    value: 'Phobos',
  },
  {
    name: 'Pyxis',
    value: 'Pyxis',
  },
  {
    name: 'Sedna',
    value: 'Sedna',
  },
  {
    name: 'Titania',
    value: 'Titania',
  },
  {
    name: 'Triton',
    value: 'Triton',
  },
  {
    name: 'Umbriel',
    value: 'Umbriel',
  },
]

export const USER_NOT_FOUND_STATUS_CODE = 404
export const USER_NOT_FOUND_ERROR_MESSAGE = 'User not found.'

export const FILTERS_SEPARATOR = '!!'
export const DEFAULT_LIMIT = 20

export const PRIVACY_POLICY_URL = 'https://www.itemize.com/privacy/'
export const TERMS_OF_SERVICE_URL = 'https://www.itemize.com/terms/'
export const WORKATO_URL =
  'https://www.workato.com/direct_link/embedded/connections/<connection_id>>?workato_dl_token='

export const DATE_SELECTOR_TYPES = {
  MTD: 'MTD',
  QTD: 'QTD',
  YTD: 'YTD',
  CUSTOM: 'CUSTOM',
  LAST_SIXTY: 'LAST_SIXTY',
  LAST_THIRTY: 'LAST_THIRTY',
}

export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_PLACEHOLDER = 'yyyy/mm/dd'
export const DATE_FORMAT_FOR_API_REQUEST = 'YYYY-MM-DD HH:MM:SS'
export const DATE_LOCALE_STRING = 'en-US'

export const BALANCE_STATUS = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  PENDING: 'Pending',
}

export const DOCUMENT_TYPES = {
  Receipt: 'receipt',
  Invoice: 'invoice',
  HotelFolio: 'folio',
}

export const FILTER_TYPES = {
  DEFAULT: 'default',
  DATE_RANGE: 'dateRange',
  MULTISELECT: 'multiSelect',
}

export const documentTypeOptions = [
  {
    value: 'receipt',
    label: 'Receipt',
  },
  {
    value: 'invoice',
    label: 'Invoice',
  },
  {
    value: 'folio',
    label: 'Hotel Folio',
  },
]

export const TODAY_DATE = moment(new Date(), DATE_FORMAT)

export const END_DATE_LABEL = 'End:'
export const START_DATE_LABEL = 'Start:'

export const DATE_OPTIONS = [
  { label: END_DATE_LABEL, value: TODAY_DATE },
  { label: START_DATE_LABEL, value: TODAY_DATE },
]

export const DATE_JOINER = ' to '

export const SEARCH_PLACEHOLDER =
  'Vendor Name, Invoice Number, Document Number, PO Number, or Total'

export const KB = platform.os?.family?.toLowerCase()?.includes('windows') ? 1024 : 1000
export const MB = KB * KB
export const GB = KB * MB
export const TB = KB * GB

// File types that will be accepted by the UI
export const ACCEPTABLE_FILE_TYPES = [
  '.7z',
  '.jpeg',
  '.jpg',
  '.png',
  '.rar',
  '.zip',
  'application/pdf',
  'application/x-zip-compressed',
  'application/zip',
  'image/jpeg',
  'image/jpg',
  'image/png',
]

export const ARCHIVE_FILE_TYPES = [
  '.7z',
  '.rar',
  '.zip',
  'application/x-zip-compressed',
  'application/zip',
  'application/x-7z-compressed',
  'application/vnd.rar',
]

export const IMAGE_FILE_TYPES = [
  'application/pdf',
  '.jpeg',
  '.jpg',
  '.png',
  'image/jpeg',
  'image/jpg',
  'image/png',
]

// File types used for limits check before upload
export const FILE_TYPES = {
  '7_ZIP_EMPTY': '',
  '7_ZIP': '.7z',
  JPEG_IMAGE: 'image/jpeg',
  JPG_IMAGE: 'image/jpg',
  MULTIPART_X_ZIP: 'multipart/x-zip',
  PDF_FILE: 'application/pdf',
  PNG_IMAGE: 'image/png',
  RAR: '.rar',
  X_ZIP_COMPRESSED: 'application/x-zip-compressed',
  X_ZIP: 'application/x-zip',
  ZIP_COMPRESSED: 'application/zip-compressed',
  ZIP_FILE: 'application/zip',
  ZIP_OCTET: 'application/octet-stream',
}
const minSize = 10
const pdfMinSize = 0
export const ACCEPTABLE_FILE_MAX_CONTENT_LENGTH = {
  [FILE_TYPES.PNG_IMAGE]: {
    MIN: minSize * KB,
    MAX: 8 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '8',
  },
  [FILE_TYPES.JPG_IMAGE]: {
    MIN: minSize * KB,
    MAX: 8 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '8',
  },
  [FILE_TYPES.JPEG_IMAGE]: {
    MIN: minSize * KB,
    MAX: 8 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '8',
  },
  [FILE_TYPES.PDF_FILE]: {
    MIN: pdfMinSize * KB,
    MAX: 8 * KB * KB,
    MIN_STRING: pdfMinSize.toString(),
    MAX_STRING: '8',
  },
  [FILE_TYPES.ZIP_FILE]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES.X_ZIP]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES.X_ZIP_COMPRESSED]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES.ZIP_COMPRESSED]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES.ZIP_OCTET]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES['7_ZIP']]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES['7_ZIP_EMPTY']]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  [FILE_TYPES.RAR]: {
    MIN: minSize * KB,
    MAX: 100 * KB * KB,
    MIN_STRING: minSize.toString(),
    MAX_STRING: '100',
  },
  COMBINED: {
    MAX: 100 * KB * KB,
    MAX_STRING: '100',
  },
}

export const FILE_UPLOAD_STATE = {
  ARCHIVE_FAILED: 'ARCHIVE_FAILED',
  COMPLETE: 'SUCCEEDED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  UPLOADING: 'UPLOADING',
}

export const FILE_METADATA_STATE = {
  FILE_METADATA_CREATED: 'CREATED',
  FILE_METADATA_CREATING: 'CREATING',
  FILE_METADATA_NOT_CREATED: 'NOT_CREATED',
}

export const NOTIFICATION_TYPES = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
}

export const SUBSCIPTION_PLAN_CODES = {
  PRO: 'pro',
  FREE: 'free',
  BUSINESS: 'business',
}

export const COMMON_STATUS = {
  ERROR: 'error',
  SUCCESS: 'success',
}

export const USER_INBOX_DOMAIN = 'itemize.com'

export const PAPER_VENDOR_TYPE = 'O'
export const DIGITAL_VENDOR_TYPE = 'E'

export const NEXT_PAGE = 'next'
export const PREVIOUS_PAGE = 'previous'
export const ZERO_VALUE_CHARGE_DATE = '0000-00-00'

export const TAG_MAPPINGS_VALUES = {
  GL_CODE_TAG: GL_CODE_PARAM,
  MY_VENDOR_TAG: MY_VENDOR_PARAM,
  EXPENSE_CATEGORY_TAG: EXPENSE_CATEGORY_PARAM,
}

export const XL_REPORT_FORMAT = 'xlsx'
export const CSV_REPORT_FORMAT = 'ccsv'

export const REPORT_FORMAT_OPTIONS = [
  {
    label: 'CSV',
    value: CSV_REPORT_FORMAT,
  },
  {
    label: 'XLSX',
    value: XL_REPORT_FORMAT,
  },
]

export const TABLE_COLUMNS_TYPES = {
  DATE: 'date',
  STRING: 'string',
  NUMBER: 'number',
  DATE_RANGE: 'dateRange',
}

export const DEFAULT_VENDOR_ICON_URL = 'https://s3.amazonaws.com/mcc_icons/shop.png'

export const GMAIL_DOMAIN = 'gmail.com'
export const OFFICE365_DOMAIN = 'outlook.com'

export const DATA_SOURCE_STATUS = {
  CRAWLING: 'Crawling',
  SYNCED: 'Email synced',
  CONNECTED: 'connected',
  NOT_CONNECTED: 'notConnected',
}

export const GMAIL_SOURCE_TYPE = 'gmail'
export const OUTLOOK_SOURCE_TYPE = 'office365'

export const DEFAULT_DATA_SOURCES = [
  {
    name: 'Gmail',
    type: GMAIL_SOURCE_TYPE,
  },
  {
    name: 'Office 365',
    type: OUTLOOK_SOURCE_TYPE,
  },
]
// Fields that will always be overwritten instead of being merged
export const MERGE_FIELDS = ['attributes', 'lineItems', 'orders']

export const GENERIC_MERCHANT = {
  name: 'test34',
  image: null,
  category: {
    id: 2100050004,
    name: 'Category Pending',
    image: 'https://s3.amazonaws.com/mcc_icons/shop.png',
    expenseCategory: {
      id: 535,
      name: 'Other Expenses',
    },
  },
  alias: null,
}

export const API_TIMEOUT_IN_SECONDS = 60

export const INBOX_STATUSES = {
  PROCESSED: 'Processed',
  PENDING: 'Pending',
  NOT_PROCESSED: 'Not Processed',
}

export const DISABLE_CATEGORY_LIST = ['Category Pending', 'Category Unknown']

export const DEFAULT_DATA_LIMIT = 40
export const DEFAULT_OFFSET_LIMIT = 20

export const WORKFLOW_STATUSES = {
  NEW: 'New',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
}

export const VENDOR_STATUSES = {
  NEW: 'New',
  VERIFIED: 'Verified',
}
export const VENDOR_STATUSES_OPTIONS = [
  { label: 'New', value: { id: 1, name: 'New' } },
  { label: 'Verified', value: { id: 1, name: 'Verified' } },
]
export const WORKFLOW_STATUSES_FILTERS = {
  New: 'New',
  Pending: 'Pending',
  Approved: 'Approved',
  Completed: 'Completed',
  Rejected: 'Rejected',
}

export const WORKFLOW_STEP_STATUSES = {
  Approved: 'Approve',
  Rejected: 'Reject',
}
export const RECONCILIATION_TABLE_ROUTES = {
  'Archive Transactions': '/archiveTransactions',
  'Transaction Matching': '/reconciliation',
  Export: 'export',
  'Archive Exports': 'archiveExports',
}

export const RECONCILIATION_COLUMN_FILTERS = {
  'Archive Transactions': 'selectedArchiveTransactionColumns',
  'Transaction Matching': 'selectedTransactionColumns',
  Export: 'selectedExportColumns',
  'Archive Exports': 'selectedExportColumns',
}

export const RECONCILIATION_STATUS_MAPPINGS = {
  'Archive Transactions': 'current',
  'Transaction Matching': 'archive',
}

export const RECONCILIATION_DEFAULT_COLUMNS_KEYS = [
  'defaultTransactionColumns',
  'defaultArchiveTransactionColumns',
  'defaultIntegrationExportColumns',
]

export const WORKFLOW_STATUSES_ARRAY = ['New', 'Pending', 'Approved', 'Rejected', 'Completed']

export const FIELD_LABEL_HASH = {
  receipt: 'Receipt',
  invoice: 'Invoice',
  folio: 'Folio',
}

export const RECONCILIATION_DATE_FIELD_HASH = {
  receipt: 'transactionDate',
  invoice: 'transactionDate',
  folio: 'startdate',
}

export const DEFAULT_EXPENSE_DETAILS_TAB = ['reconciliation', 'archiveTransactions']

export const PO_MISS_MATCH_REASONS = [
  'line_item_mismatch',
  'vendor_mismatch',
  'quantity_mismatch',
  'unit_price_mismatch',
]

export const PO_MATCH_REASONS_WITH_FIELD_NAMES = {
  purchaseOrderVendor: 'vendor_mismatch',
  invoiceVendor: 'vendor_mismatch',
  numberOfUnits: 'quantity_mismatch',
  unitPrice: 'unit_price_mismatch',
  sku: 'sku_mismatch',
}

export const reportTypes = [
  {
    description: 'Risk scores and details for your documents',
    formats: ['CSV', 'XLSX'],
    path: 'risk-score',
    template: { id: 3, name: 'compliance' },
    title: 'Risk Score Details',
    type: 'confidenceScore',
  },
  {
    description: 'Audit log of changes to your documents',
    formats: ['CSV', 'XLSX'],
    path: 'audit-log',
    template: { id: 2, name: 'audit' },
    title: 'Document Audit Log',
    type: 'auditLog',
  },
  {
    description: 'Specific information from your documents',
    formats: ['CSV', 'XLSX', 'PDF'],
    path: 'expense-details',
    template: { id: 1, name: 'expensedetail' },
    title: 'Expense Details',
    type: 'expenseDetails',
  },
  {
    description: 'Specific information from your Transaction Matching',
    formats: ['CSV', 'XLSX'],
    path: 'reconciliation',
    template: { id: 1, name: 'reconciliation' },
    title: 'Reconciliation',
    type: 'reconciliation',
  },

  {
    description: 'Specific information from your Export',
    formats: ['CSV', 'XLSX'],
    path: 'export',
    template: { id: 1, name: 'appfolioexport' },
    title: 'Export',
    type: 'expenseDetails',
  },
]
